import React from "react";
import "./Titles.css";

function Titles() {
  return (
    <div className="app-titles">
      <a href="https://github.com/Luzkan/GitVersioniser" className="app-title">GitVersioniser</a>
      <p className="app-subtitle">
        Automatic Semantic Versioniser & Change Tracker
      </p>
    </div>
  );
}

export default Titles;
